import { AutocompleteInputChangeReason } from '@mui/material';

import { ICTVCode } from '@/models';

export const shouldUpdateSearchText = (reason: AutocompleteInputChangeReason) =>
  reason === 'input' || reason === 'clear';

export const shouldUpdateDisplayedText = (
  reason: AutocompleteInputChangeReason,
) => reason === 'input' || reason === 'clear' || reason === 'reset';

export const getCtvCodeLabel = ({
  code,
  locationLiteral,
  geographicType,
}: Pick<ICTVCode, 'code' | 'locationLiteral' | 'geographicType'>) =>
  `${code} - ${locationLiteral} - ${geographicType}`;
